module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chart-container",
    staticStyle: {
      "position": "relative",
      "width": "100%"
    }
  }, [(_vm.chartData) ? _c('bar-chart', {
    attrs: {
      "chartData": _vm.chartData
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e75befea!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/event/EventStatistics.vue
// module id = 1039
// module chunks = 2